module.exports = __webpack_public_path__ + "static/media/arrow-right.f0d14356.svg";